/*
* Theme scripts.
*/

/*var locoScroll = new LocomotiveScroll({
    el: document.querySelector('[data-scroll-container]'),
    smooth: true,
    getDirection: true,
});*/


/* Make it global */
/*
window.loco = locoScroll;
*/

/*
let resizePage = 0;
*/

/*locoScroll.on('scroll', (instance) => {

    document.documentElement.setAttribute('data-direction', instance.direction);

    if (instance.scroll.y > 200 && $(window).width() > 480) {
        document.documentElement.classList.add('-watch-direction');
    } else {
        document.documentElement.classList.remove('-watch-direction');
    }

    // scroll top position
    if (instance.scroll.y > 20) {
        document.documentElement.classList.add('scrolled');
    } else {
        document.documentElement.classList.remove('scrolled');
    }

    fnInViewDetect();

    jQuery('.stats').each(fnCounterUp); 	// Counter

    /!**
     * Force the page size to load again
     * when it hits footer.
     *!/
    if (typeof instance.currentElements['footer'] === 'object' && resizePage < 1) {
        window.dispatchEvent(new Event('resize'));
        resizePage = 1;
    }

    ScrollTrigger.update
});*/


/*
locoScroll.on("scroll", ScrollTrigger.update);
/!**
 * GSAP Scroll Trigger Proxy (LocomotiveScroll)
 *!/
ScrollTrigger.scrollerProxy(".scroll-container", {
    scrollTop(value) {
        return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y;
    },
    getBoundingClientRect() {
        return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
    },
    pinType: document.querySelector(".scroll-container").style.transform ? "transform" : "fixed"
});

gsap.registerPlugin(ScrollTrigger);
*/



(function ($) {
    'use strict';

    $('body').scroll(function(){
        $('.stats').each(fnCounterUp); 	// Counter
    });

    /**
     * Initiate independent functions
     */
    function fnInit() {

        fnInViewDetect();													// In-viewport detection (lazy-loading)
        $('body').on('click', 'a.hash-link', fnScrollToID);	// Smooth anchor links
        $('body').addClass('page-loaded');						// Page loaded class
        $('.lazy').each(fnLazyLoad);										// Lazyload images (performance)
        $('section.hero-home').each(fnHeroHome);							// Hero Home
        fnHamburgerMenu();                                                  // Header Hamburger Menu
        $('.tabs').each(fnTabs); 											// Tabs
        $('section.image-text-accordion').each(fnAccordion); 				// Accordion
        $('section.logos-ticker').each(fnLogosTicker); 						// Logos Ticker
        $('.stats').each(fnCounterUp); 						                // Counter
        /*
                $('video.main-video').each(fnResponsiveVideoLoading); 				// Video Load Resolution
        */
        $('[data-splitting], .menu-item').each(fnSplitText);         		// Split Text  
        $('.gform_wrapper').each(fnGform);         				            // GForm
        $('div.custom-cursor').each(fnCustomCursor);                        // Custom Cursor
        $('section.timeline-carousel').each(fnTimelineCarousel);			// Timeline carousel
        $('section.features-carousel').each(fnFeaturesCarousel);			// Features carousel
        $('section.testimonials-carousel').each(fnTestimonialsCarousel);	// Testimonials carousel
        $('section.case-studies-slider').each(fnCaseStudiesSlider);	        // Case Studies Slider
        $('section.media-carousel').each(fnMediaCarousel);                // Media carousel
        $('section.crosslinks').each(fnCrosslinksCarousel);               // Crosslinks Carousel
        $('section.values-slider').each(fnValuesSlider);                  // Values Slider
        $('section.landing-logos-slider').each(fnLogosSlider);                  // Values Slider
        $("[data-paroller-factor]").paroller();
        $('section.looking-glass').each(fnLookingGlass); // Looking Glass
        $('section.network-diagram').each(fnNetworkDiagram); // Network Diagram
        $('section.blog-listing').each(fnBlog); // Blog

 
        //$('#posts-grid').each(fnPostsGrid);                                 //Posts Grid

        $('select').dropkick({mobile: true});                     // Select drop-down styling (Dropkick.js)

        $('header.primary').each(fnHeaderPrimary);
        $('header.landing-page-header').each(fnHeaderPrimary);

        /*Menu Items Hover*/
        if ($(window).width() > 1024) {
            $('.primary-menu .menu-item.has-submenu').mouseover(function () {
                $('header.primary').addClass('is-opened');
                $(this).addClass('is-active');
            })
                .mouseout(function (e) {
                    $('header.primary').removeClass('is-opened');
                    $(this).removeClass('is-active');
                });
        }

        $('body').on('click', 'header.primary .button.popup, a[href="#contact-popup"]', function (e) {
            $('#contact-popup').addClass('is-active');
            //locoScroll.stop();
            e.preventDefault();
        });					// Contact Popup Open

        $('body').on('click', '#contact-popup .close-button', function (e) {
            $('#contact-popup').removeClass('is-active');
            //locoScroll.start();
            e.preventDefault();
        });					// Contact Popup Close

        // Positions Section
        $(document).on('click', 'section.positions .arrow', function (ev) {
            $(this).parent().toggleClass('is-active');
            ev.preventDefault();
        });
        $(document).on('click', 'section.positions .tab-title', function (ev) {
            var sText = $(this).text();
            var sCat = $.trim(sText);
            $('.tab-title').removeClass('is-current');
            $(this).addClass('is-current');
            console.log(sCat);

            if (sCat === 'ALL') {
                $('section.positions .position').addClass('is-current');
            } else {
                $('section.positions .position').removeClass('is-current');
                $("section.positions .position[data-category='" + sCat + "']").addClass('is-current');
            }
            setTimeout(function () {
                //locoScroll.update();
            }, 500)
            ev.preventDefault();
        });

        $('.mobile-toggler').on('click', function (){
            $(this).toggleClass('active');
            $(this).next('.categories-list').toggleClass('active');
        });

        // Landing Page:


        $('.page-template-template_retail-project-landing-page a[href="#enquiry"], .page-template-template_landing-page a[href="#enquiry"]').on('click', function (e) {
            $('#form-modal').toggleClass('is-active'); 
            e.preventDefault();
        });

        $('.page-template-template_retail-project-landing-page a[href="#close-modal"], .page-template-template_landing-page a[href="#close-modal"]').on('click', function (e) {
            $('#form-modal').toggleClass('is-active');
            e.preventDefault();
        });

        $('section.landing-page-hero .scroll-to-next').on("click", function(e) {
            const nextSection = $(this).parents('section').first().next('section');
            $('html, body').animate({
                scrollTop: nextSection.offset().top - 50,
            });
        })

        $('a[href="#our-packages"]').on("click", function(e) {
            const nextSection = $('#our-packages');
            $('html, body').animate({
                scrollTop: nextSection.offset().top - 50,
            });
        })

    }

    fnInit();


}(jQuery));

/*
// each time the window updates, we should refresh ScrollTrigger and then update LocomotiveScroll.
ScrollTrigger.addEventListener("refresh", () => locoScroll.update());

// after everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
ScrollTrigger.refresh();*/
